import React, { useState } from 'react';

export default function Accordion({ title, children, defaultOpen = false }: { title: string, children: any, defaultOpen: boolean }) {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="overflow-hidden my-2 border-b-1 pb-4 border-gray-500">
      <button
        onClick={toggleAccordion}
        className="flex justify-between items-center w-full p-4 text-left font-semibold transition duration-300"
        aria-expanded={isOpen}
      >
        <span>{title}</span>
        <span className={`w-5 h-5 me-4 transition-transform duration-300 ${isOpen ? 'font-bold' : 'font-regular'
          }`}>
          {isOpen ? '-' : '+'}
        </span>
      </button>
      <div
        className={`
          transition-max-height duration-300 ease-in-out 
          ${isOpen ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'} 
          overflow-hidden 
        `}
      >
        <div className="px-4 py-2">
          {children}
        </div>
      </div>
    </div>
  );
}